import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {GtmGa4EventDirective} from '../directives/gtm-ga4-event.directive';
import {GtmEventDirective} from '../directives/gtm-event.directive';

@NgModule({
  imports: [RouterModule, CommonModule],
  providers: [],
  declarations: [GtmGa4EventDirective, GtmEventDirective],
  bootstrap: [],
  exports: [GtmGa4EventDirective, GtmEventDirective],
})
export class SharedTrackingModule {}
